import React, { useCallback } from 'react';

import { useAtomValue } from 'jotai';
import { useParams } from 'react-router-dom';

import { avoidancePolicyRulesGroupsAtomFamily, policyDefinitionsAtomFamily } from 'atoms/events';
import AvoidancePanel from 'components/panels/eventsSplitDraws/avoidance/avoidancePanel/AvoidancePanel';
import CreateAvoidanceContainer from 'containers/eventsSplitDraws/avoidance/CreateAvoidanceContainer';

const AvoidancePanelContainer: React.FC = () => {
  const [open, setOpen] = React.useState(false);
  const { eventId } = useParams<{ eventId: string }>();
  const policyDefinitions = useAtomValue(policyDefinitionsAtomFamily(eventId));
  const { rules, groups } = useAtomValue(avoidancePolicyRulesGroupsAtomFamily(eventId));

  const handleOpenAddAvoidance = useCallback(() => {
    setOpen(true);
  }, []);
  const handleCloseAddAvoidance = useCallback(() => {
    setOpen(false);
  }, []);

  return (
    <>
      <AvoidancePanel existingGroups={groups} existingRules={rules} onAddAvoidance={handleOpenAddAvoidance} />
      <CreateAvoidanceContainer
        existingGroups={groups}
        existingRules={rules}
        isOpen={open}
        policyDefinition={policyDefinitions}
        onClose={handleCloseAddAvoidance}
      />
    </>
  );
};

export default AvoidancePanelContainer;
